import { appConfig } from 'config/environment/appConfig'

import { HttpService } from 'services/HttpService'
import convertKeysToCamelCase from 'utils/helpers/convertKeysToCamelCase'
import { ResponseListData } from 'shared/types/types'

import {
  ActivateELockRequest,
  ELockConnectInfoDTO,
  ELockInfoRequest,
  SetELockReasonRequest,
  UpdateELockRequest,
} from './types'

const discoveryService = new HttpService(appConfig.DISCOVERY_URL)

export const eLockApi = {
  activateELock: async ({ eLockName, orderId, photos }: ActivateELockRequest): Promise<boolean> => {
    return await discoveryService.post<boolean>('/api/v2/pickpoint-order/elock/activate', {
      body: {
        pickpoint_order_id: orderId,
        elock_name: eLockName,
        photos,
      },
    })
  },

  /** @see https://youtrack.wildberries.ru/articles/ED-A-133 (описание запроса)*/
  getELockConnectInfo: async ({
    orderId,
    employeeId,
    lockName,
    lockNoSet,
    ttl = 6,
    tokenType = 1,
  }: ELockInfoRequest): Promise<ELockConnectInfoDTO | undefined> => {
    const result = await discoveryService.post<ResponseListData<ELockConnectInfoDTO> | undefined>(
      '/api/v4/pickpoint-order/elock/get-token',
      {
        body: {
          pickpoint_id: orderId,
          employee_id: employeeId,
          lock_name: lockName,
          token_type: tokenType,
          lock_no_set: lockNoSet,
          ttl,
        },
      },
    )

    return result?.data ? convertKeysToCamelCase(result.data) : undefined
  },

  setELockReason: async (data: SetELockReasonRequest): Promise<boolean> => {
    const res = await discoveryService.post<ResponseListData<boolean>>('/api/v2/pickpoint-order/elock/set-reason', {
      body: {
        pickpoint_order_id: data.orderId,
        reason: data.reason,
        description: data.description,
        photos: data.photos,
      },
    })

    return res?.data
  },

  updateELock: async (data: Partial<UpdateELockRequest>): Promise<boolean> => {
    const updatedFields = Object.entries(data)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key]) => key)

    /* Если указано имя замка, то обновляем фото замка (контроллер и тд), иначе обновляем форму причины активации без замка */
    const reasonForm = data.eLockName
      ? undefined
      : {
          reason: data.reason,
          description: data.description,
          update_fields: updatedFields,
        }

    const res = await discoveryService.post<ResponseListData<boolean>>('/api/v2/pickpoint-order/elock/update', {
      body: {
        pickpoint_order_id: data.orderId,
        elock_name: data.eLockName,
        photos: data.photos,
        ...reasonForm,
      },
    })

    return res?.data
  },
}
